export default __webpack_public_path__ + "static/media/qr-code.ba449738.svg";